import OutsideRenderer from './OutsideRenderer';

export default OutsideRenderer;
